import { render, staticRenderFns } from "./WidgetMyAccountNav.vue?vue&type=template&id=1f3c5414&scoped=true&"
import script from "./WidgetMyAccountNav.vue?vue&type=script&lang=js&"
export * from "./WidgetMyAccountNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c5414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3c5414')) {
      api.createRecord('1f3c5414', component.options)
    } else {
      api.reload('1f3c5414', component.options)
    }
    module.hot.accept("./WidgetMyAccountNav.vue?vue&type=template&id=1f3c5414&scoped=true&", function () {
      api.rerender('1f3c5414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/WidgetMyAccountNav.vue"
export default component.exports